import { ElLoading } from 'element-plus'
import { nextTick } from 'vue'

export let loading: ReturnType<typeof ElLoading.service> | null

export const openLoading = (msg: string) => {
  loading = ElLoading.service({
    lock: true,
    text: msg,
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

export const closeLoading = () => {
  // console.log('closeLoading:', loading)
  nextTick(() => {
    if (loading && typeof loading.close === 'function') {
      loading.close()
      // 重置引用，避免后续误用已关闭的实例
      loading = null
    }
  })
}
